module.exports = __webpack_public_path__ + "static/MC_virtual_clasica_full-8688064d31471278772933843c86d07e.jpg";